module.exports = require("@splunk/visualization-context/GeoJsonProvider");